<template>
    <div>
        <div v-if="isLoading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <app-form v-bind:parentObject="{
                // data: this.formData,
                // pageTitle: this.pageTitle,
                // pageTitleValue: this.pageTitleValue,
                // errMsg: this.errMsg,
                // isExsiting: this.isExsiting,

                // pmRewardBasicSalaryDetailList: this.pmRewardBasicSalaryDetailList,
                // pmRewardBonusDetailList: this.pmRewardBonusDetailList,
                // pmRewardInstruction: this.pmRewardInstruction,
            }" v-on:input="formData = $event" v-on:error="errorHandler" />

            <div v-if="isErr">
                <app-error v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }" v-on:closeError="isErr = $event" />
            </div>
        </div>
    </div>
</template>

<script>
import PMRewardSimulationForm from "../../../components/performance/rewardsimulation/Form2";
//import moment from 'moment';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": PMRewardSimulationForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rewardid: this.$route.params.rewardid,
            assessmentid: this.$route.params.assessmentid,

            pageTitle: '',// this file is just a base, nothing use in here
            pageTitleValue: null,

            formData: {
                id: null,
                rewardrecordid:null,
                pmassessmentrecordid: null,
                targetbonusamt: null,
                targetincrementamt: null,
                stamp: null,
                updatedby: this.$store.getters.userId,
            },
            errMsg: "",
            isErr: false,
            isLoading: true,
            isExsiting: false,
        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

    },

    async mounted() {
        try {
         
            this.isLoading = false; // Set loading to false after all data is loaded
        } catch (error) {
            console.error("Something went wrong during mounted:", error);
            this.isErr = true;
            this.errMsg = error;
        }
    }
};
</script>